/* Smooth inertial scrolling (Lenis). Turns chunky mouse-wheel steps into one
   fluid motion and keeps the scroll-driven journey animation buttery. Loads Lenis
   lazily; if it fails or reduced-motion is on, the page falls back to native
   scroll with zero impact. Touch devices keep native scrolling. */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/lenis@1.1.14/dist/lenis.min.js';
  s.crossOrigin = 'anonymous';
  s.onload = function () {
    if (!window.Lenis) return;
    var lenis = new Lenis({
      lerp: 0.1,            // smoothing factor (higher = snappier)
      smoothWheel: true,   // smooth the mouse wheel (the Windows fix)
      wheelMultiplier: 1,
      touchMultiplier: 1.5
    });
    window.lmpLenis = lenis;

    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);

    /* Smooth same-page anchor jumps, offset for the fixed header. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.length < 2) return;
      var target;
      try { target = document.getElementById(href.slice(1)) || document.querySelector(href); } catch (err) { return; }
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -84, duration: 1.1 });
    });
  };
  document.head.appendChild(s);
})();
